import './App.css';
import {ConfigProvider} from 'antd';
import Aos from 'aos';
import 'aos/dist/aos.css';
import {useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';

import JsonData from './data/data.json';
import {AboutUs} from './screenComponent/AboutUs';
import {Careers} from './screenComponent/Careers';
import {Channel_partners} from './screenComponent/Channel_partners';
import {ContactUs} from './screenComponent/ContactUs';
import {GalleryScreen} from './screenComponent/GalleryScreen';
import {HomeScreen} from './screenComponent/HomeScreen';
import {LayoutComponent} from './screenComponent/LayoutComponent';
import {OurProcess} from './screenComponent/OurProcess';
import {ProductPage} from './screenComponent/ProductPage';
import {ScrollToTop} from './screenComponent/ScrollToTop';

function App() {
  useEffect(() => {
    Aos.init({duration: 1100, once: true});
  }, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#502f27',
        },
      }}
    >
      <div>
        <ScrollToTop />
        <Routes>       
          <Route path={'/'} element={<LayoutComponent />}>
            <Route index element={<HomeScreen />} />
            <Route path={'/about'} element={<AboutUs data={JsonData.AboutUs} />} />
            <Route path={'/products'} element={<ProductPage data={JsonData.ProductSection} />} />
            <Route path={'/gallery'} element={<GalleryScreen data={JsonData} />} />
            <Route path={'/contact-us'} element={<ContactUs data={JsonData.ContactUs} />} />
            <Route path={'/channel'} element={<Channel_partners data={JsonData.channel_partners1} />} />
            <Route path={'/ourProcess'} element={<OurProcess data={JsonData.channel_partners1} />} />
            <Route path={'/careers'} element={<Careers data={JsonData.channel_partners1} />} />
          </Route>    
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;
